<!--
 * @Author: daidai
 * @Date: 2022-02-28 16:29:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-25 15:45:57
 * @FilePath: \web-pc\src\pages\big-screen\components\echart\index.vue
-->
<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import tdTheme from './theme.json' // 引入默认主题

export default {
  name: 'echart',
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    options: {
      type: Object,
      default: ()=>({})
    },
    screenWidth: {
      type: Number,
      default: 0
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    options: {
      handler (options) {
        // 设置true清空echart缓存
        this.chart.setOption(options, true)
      },
      deep: true
    },
    screenWidth(newV,oldV) {
      this.changeMobile(newV)
    }
  },
  created(){
    console.log('echarts id: ' , this.id)
    console.log('echarts setting: ' , this.options)
  },
  mounted () {
    // echarts.registerTheme('tdTheme', tdTheme); // 覆盖默认主题
    this.initChart();
    this.changeMobile(this.screenWidth)
  },
  beforeDestroy () {
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    changeMobile(newV){
      if (newV) {
        this.$nextTick(function(){
          this.chart.resize()
        })
      }
    },
    initChart () {
      // 初始化echart
      this.chart = this.$echarts.init(this.$el, 'tdTheme')
      this.chart.setOption(this.options, true)
    },
    bindClick(){
      // 为echarts对象加载数据 
      this.chart.on('click', function (params) {
          // 控制台打印数据的名称
          console.log(params.name);
          // 在这里添加你的点击事件逻辑
      });
    },
    getChart(){
      return this.chart
    }
  }
}
</script>

<style>
</style>
